/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { CommonHeadersBuilder } from '@core/api/utils/common-headers-builder';
import { AssistedHeadersBuilder } from '@core/api/utils/assisted/assisted-headers-builder';
import { WebHeadersBuilder } from '@core/api/utils/web/web-headers-builder';
import { RapHeadersBuilder } from '@core/api/utils/rap/rap-headers-builder';
import { HttpHeaders } from '@angular/common/http';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';

// @TODO is this public outside of Core?
// @TODO add documentation
export class HeadersBuilderFactory {
  constructor(
    private stateStoreUtil: StateStoreUtilsService,
    private commonUtil: CommonUtilService
  ) {}

  public getHeaderbuilder(headers: HttpHeaders, channeltype: string): CommonHeadersBuilder {
    switch (channeltype) {
      case 'web':
        return new WebHeadersBuilder(headers, this.stateStoreUtil, this.commonUtil);
      case 'nrd':
        return new RapHeadersBuilder(headers, this.stateStoreUtil, this.commonUtil);
      default:
        return new AssistedHeadersBuilder(headers, this.stateStoreUtil, this.commonUtil);
    }
  }
}
